module.exports = __webpack_public_path__ + "src/images/measurements/underBust.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/underBust.jpg
// module id = 1160
// module chunks = 0